(() => {
  const rootSelector = '.futureblink-bundle-block';
  const script = document.currentScript;
  const hideCurrentProduct = script?.dataset.hideCurrentProductInBundle === 'true';
  const currentProductId = String(
    script?.dataset.currentProductId ||
      window._fetherStore?.product?.id ||
      window.ShopifyAnalytics?.meta?.product?.id ||
      ''
  );
  const pricePattern = /^\$([\d,]+)\.00$/;

  const formatUsd = (amount) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

  const normalizePrice = (node) => {
    if (!(node instanceof HTMLElement) || node.dataset.hoppyPriceNormalized === 'true') return;

    const text = node.textContent.trim();
    const match = text.match(pricePattern);
    if (!match) return;

    const amount = Number(match[1].replace(/,/g, ''));
    if (!Number.isFinite(amount) || amount < 1000) return;

    node.dataset.hoppyOriginalPrice = text;
    node.dataset.hoppyPriceNormalized = 'true';
    node.textContent = formatUsd(amount / 100);
  };

  const normalizeHoppyPrices = () => {
    document.querySelectorAll(`${rootSelector} .futureBlink_slide p`).forEach(normalizePrice);
  };

  const readProductId = (item) => {
    const direct =
      item.getAttribute('product-id') ||
      item.getAttribute('data-product-id') ||
      item.dataset.productId ||
      item.querySelector('[product-id]')?.getAttribute('product-id') ||
      item.querySelector('[data-product-id]')?.getAttribute('data-product-id') ||
      item.querySelector('input[name="product-id"], input[name="product_id"]')?.value ||
      '';
    return String(direct).replace(/\D/g, '');
  };

  const hideCurrentBundleItem = () => {
    if (!hideCurrentProduct || !currentProductId) return;
    const currentId = currentProductId.replace(/\D/g, '');
    const items = [
      ...document.querySelectorAll(`${rootSelector} .futureBlink_slide`),
      ...document.querySelectorAll('mpb-fbt [data-index="product-trigger"]'),
    ];
    items.forEach((item) => {
      const isCurrentTrigger = item.getAttribute('data-index') === 'product-trigger';
      if (!isCurrentTrigger && readProductId(item) !== currentId) return;
      item.setAttribute('data-hoppy-current-product', 'true');
      item.querySelectorAll('input, button, [role="checkbox"]').forEach((control) => {
        if (control.type === 'checkbox' || control.type === 'radio') control.checked = false;
        control.disabled = true;
      });
    });
  };

  if (hideCurrentProduct) {
    const style = document.createElement('style');
    style.textContent = '[data-hoppy-current-product="true"]{display:none !important;}';
    document.head.appendChild(style);
  }

  normalizeHoppyPrices();
  hideCurrentBundleItem();

  const observer = new MutationObserver(() => {
    normalizeHoppyPrices();
    hideCurrentBundleItem();
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
